import NiceModal from '@ebay/nice-modal-react'
import { UserApi, UserProfileModel } from 'mvppoker-portal-common/api'
import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import { updateService } from '../../../../logic/UpdateService'
import { useActiveUser } from '../../../../state/hooks/ActiveUserHooks'
import { createMVPModal } from '../../Modal'
import { useOtherProfilesLookup } from '../../../../state/hooks/ProfileDataHooks'
import { handleError, useApi } from '../../../../utils/useApi'
import { FriendsRequestsModalView } from './FriendsRequestsModalView'

class FriendsRequestsModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('friends-requests-modal', () =>
		{
			const user = useActiveUser()
			const otherProfilesLookup = useOtherProfilesLookup()
			const api = useApi(UserApi)

			const [isRefreshing, setRefreshing] = useState(false)

			const requests = user?.user.friends.requestsReceived.map(f => otherProfilesLookup[f]).filter(f => f) ?? []

			const clickRefresh = () => {
				setRefreshing(true)
		
				updateService.refreshUser(() => {
					setRefreshing(false)
				})
			}
			const clickAccept = (userProfile: UserProfileModel) => {
				api
				.usersFriendsAccept({ value: userProfile.userId })
				.then(() => {
					toast.success('Friend Added!')
					clickRefresh()
				})
				.catch((err) => {
					handleError(err)
				})
			}
			const clickReject = (userProfile: UserProfileModel) => {
				api
				.usersFriendsReject({ value: userProfile.userId })
				.then(() => {
					toast.success('Request Rejected!')
					clickRefresh()
				})
				.catch((err) => {
					handleError(err)
				})
			}

			return <FriendsRequestsModalView 
				requests={requests}
	
				clickRefresh={clickRefresh}
				isRefreshing={isRefreshing}
				friendsRequestsListItemActions={{
					clickAccept,
					clickReject
				}}
			/>
		}))
	}
}

const modal = new FriendsRequestsModal()
export default modal
